import React, { useContext, useEffect } from "react";
import MyContext from "../context/MyContext";
import axios from "axios";
import Loading from "./Loading";
import { useHistory, useParams } from "react-router-dom";

const initialState = {
  product_id: "",
  title: "",
  price: 0,
  prevPrice: 0,
  description:
    "How to and tutorial videos of cool CSS effect, Web Design ideas,JavaScript libraries, Node.",
  content:
    "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  category: "",
  _id: "",
};

const CreateProduct = () => {
  const context = useContext(MyContext);
  const {
    isAdmin,
    product,
    setProduct,
    categories,
    images,
    setImages,
    loading,
    setLoading,
    products,
    onEdit,
    setOnEdit,
    callback,
    setCallback,
  } = context;
  const history = useHistory();
  const param = useParams();

  useEffect(() => {
    if (param.id) {
      setOnEdit(true);
      products.forEach((product) => {
        if (product._id === param.id) {
          setProduct(product);
          setImages(product.images);
        }
      });
    } else {
      setOnEdit(false);
      setProduct(initialState);
      setImages([]);
    }
  }, [param.id, products, setImages, setOnEdit, setProduct]);

  const handleUpload = async (e) => {
    e.preventDefault();
    try {
      if (!isAdmin) return alert("You're not an admin");
      const files = e.target.files;
      let formData = new FormData();
      for (let file of files) {
        if (!file) return alert("File not exist.");
        if (file.size > 1024 * 1024) return alert("Size too large!");
        if (file.type !== "image/jpeg" && file.type !== "image/png")
          return alert("File format is incorrect.");
        formData.append("files", file);
      }

      setLoading(true);
      const res = await axios.post("/api/upload", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      setLoading(false);
      setImages(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDestroy = async (image) => {
    try {
      if (!isAdmin) return alert("You're not an admin");
      setLoading(true);
      await axios.post("/api/destroy", { public_id: image.public_id });
      setLoading(false);
      setImages(images.filter((item) => item.public_id !== image.public_id));
      // setImages([]);
    } catch (err) {
      alert(err.response.data.msg);
    }
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!isAdmin) return alert("You're not an admin");
      if (!images) return alert("No Image Upload");
      if (onEdit) {
        await axios.put(`/products/${product._id}`, { ...product, images });
      } else {
        await axios.post("/products", { ...product, images });
      }
      setCallback(!callback);
      history.push("/");
    } catch (err) {
      alert(err.response.data.msg);
    }
  };

  const styleUpload = {
    display: images.length > 0 ? "block" : "none",
  };

  
  const imagesList = images.map((image) => {
    return (
      <div className="product-image" key={image.url}>
        <img src={image.url} alt="" />
        <span onClick={() => handleDestroy(image)}>X</span>
      </div>
    );
  });

  return (
    <div className="create_product">
      <div className="upload">
        <input
          type="file"
          name="file"
          id="file_up"
          onChange={handleUpload}
          multiple
        />
        {loading ? (
          <div id="file_img">
            <Loading />
          </div>
        ) : (
          <div id="file_img" style={styleUpload}>
            {imagesList}
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <input
            type="text"
            name="product_id"
            id="product_id"
            placeholder="Product ID"
            required
            value={product.product_id}
            onChange={handleChangeInput}
            disabled={onEdit}
          />
        </div>

        <div className="row">
          <input
            type="text"
            name="title"
            id="title"
            placeholder="Title"
            required
            value={product.title}
            onChange={handleChangeInput}
          />
        </div>

        <div className="row">
          <input
            type="number"
            name="price"
            id="price"
            placeholder="Price"
            required
            value={product.price}
            onChange={handleChangeInput}
          />
        </div>
        <div className="row">
          <input
            type="number"
            name="prevPrice"
            id="prevPrice"
            placeholder="Previous Price"
            required
            value={product.prevPrice}
            onChange={handleChangeInput}
          />
        </div>

        <div className="row">
          <textarea
            type="text"
            name="description"
            id="description"
            placeholder="Description"
            maxLength="60"
            required
            value={product.description}
            rows="3"
            onChange={handleChangeInput}
          />
        </div>

        <div className="row">
          <textarea
            type="text"
            name="content"
            id="content"
            placeholder="Content"
            required
            value={product.content}
            rows="7"
            onChange={handleChangeInput}
          />
        </div>

        <div className="row category">
          <label htmlFor="categories">Categories: </label>
          <select
            name="category"
            value={product.category}
            onChange={handleChangeInput}
          >
            <option value="">Please select a category</option>
            {categories.map((category) => (
              <option value={category._id} key={category._id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-button">
          <button type="submit">{onEdit ? "Update" : "Create"}</button>
        </div>
      </form>
    </div>
  );
};

export default CreateProduct;
